import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingCampaign,
  UpdateMarketingCampaignPayload
} from "../../marketing.types";
import { requestUpdateMarketingCampaign } from "./updateMarketingCampaign.request";

const useUpdateMarketingCampaign = (
  options?: MutationOptions<
    MarketingCampaign,
    ApiServiceError<ApiError>,
    UpdateMarketingCampaignPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateMarketingCampaign,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "campaigns"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateMarketingCampaign;
